<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-blockchain`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 5a2 2 0 00-2-2H4a2 2 0 00-2 2v26a2 2 0 002 2h12v10a2 2 0 002 2h26a2 2 0 002-2V17a2 2 0 00-2-2H32V5zM6 7h22v8H18a2 2 0 00-2 2v8h4v-6h22v22H20v-8h10a2 2 0 002-2v-8h-4v6H6V7z"/></svg>
</template>
<script>

export default {
  name: 'IconBlockchain',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
